<!-- 总评center地图 -->
<style lang="stylus" scoped>
.map {
  width: 655px;
  height: 630px;
  margin: 0 auto;

  .main {
    width: 100%;
    height: 100%;

    #bgImage {
      background: url('../../../../../static/img/dashboard/tip.png') no-repeat;
      background-size: contain;
    }
  }
}
</style>

<template>
  <div class="map">
    <div class="main"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import axios from "axios";
import tipbg from "../../../../../static/img/dashboard/tip.png";
export default {
  data() {
    return {
      myChart: {}
    };
  },
  components: {},
  mounted: function() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector(".map .main"));
    const self = this;

    axios.get("static/data/百色市.json").then(function(res) {
      // 引入地区地图
      echarts.registerMap("百色市", res.data);
      // 每个地区的坐标
      const geoCoordMap = {
        '右江区': [106.6189648699, 23.9011510432],
        '靖西市': [106.4176986464, 23.1340325224],
        '田阳县': [106.9156629745, 23.735669975],
        '田东县': [107.1260862186, 23.5972525589],
        '平果县': [107.5898772387, 23.3293469441],
        '德保县': [106.6154958178, 23.3234056946],
        '那坡县': [105.8335036062, 23.3871180613],
        '凌云县': [106.561596792, 24.3475183354],
        '乐业县': [106.5616359496, 24.7858389344],
        '田林县': [106.2285227061, 24.2943864015],
        '西林县': [105.0938229983, 24.4895710923],
        '隆林各族自治县': [105.3438807417, 24.7706591482]
      };

      // 每个地区的设备数量值
      const data = [
        { name: "右江区", value: 10 },
        { name: "靖西市", value: 20 },
        { name: "田阳县", value: 30 },
        { name: "田东县", value: 10 },
        { name: "平果县", value: 20 },
        { name: "德保县", value: 30 },
        { name: "那坡县", value: 10 },
        { name: "凌云县", value: 20 },
        { name: "乐业县", value: 30 },
        { name: "田林县", value: 30 },
        { name: "西林县", value: 30 },
        { name: "隆林各族自治县", value: 30 }
      ];

      const convertData = function(data) {
        const res = [];
        for (let i = 0; i < data.length; i++) {
          const geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            });
          }
        }
        return res;
      };

      function tooltipCharts() {
        const tooltipDom = document.getElementById("tooltipPieId");
        if (tooltipDom) {
          const tooltipCharts = echarts.init(
            document.getElementById("tooltipPieId")
          );
          const data = [
            { name: "百色芒果", value: 35.02 },
            { name: "香芒", value: 9.5 },
            { name: "百色番茄", value: 7.6 },
            { name: "沙塘桔", value: 2.4 },
            { name: "其他", value: 34.5 }
          ];
          let total = 0;
          for (var i = 0; i < data.length; i++) {
            total = Math.round((total + data[i].value) * 100) / 100;
          }
          const tooltopOpiton = {
            color: [
              "#CC68FA",
              "#FF6438",
              "#35CDFD",
              "#FF7B7B",
              "#FFFE75",
              "#22FAA1"
            ],
            title: {
              text: "总数",
              subtext: total,
              textStyle: {
                fontSize: 12,
                color: "#fff",
                align: "center"
              },
              subtextStyle: {
                fontSize: 12,
                color: "#fff"
              },
              x: "12%",
              y: "33%"
            },
            grid: {
              bottom: 150,
              left: 100,
              right: "10%"
            },
            legend: {
              right: "right",
              top: "-4%",
              textStyle: {
                color: "#f2f2f2",
                fontSize: 12
              },
              icon: "pin",
              data,
              formatter: function(name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    const n = Math.round((data[i].value / total) * 10000) / 100
                    return `${name} ${n}% ${data[i].value}`;
                  }
                }
              }
            },
            series: [
              {
                radius: ["40%", "70%"],
                center: ["20%", "50%"],
                type: "pie",
                itemStyle: {
                  normal: {
                    areaColor: "#328DDF",
                    borderColor: "#BCC5EA",
                    borderWidth: 0
                  },
                  borderWidth: 10,
                  shadowColor: "rgba(0, 0, 0, 0)",
                  shadowBlur: 10
                },
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                name: "信息统计",
                data
              }
            ]
          };
          tooltipCharts.setOption(tooltopOpiton);
        }
      }

      const option = {
        // 地图映射颜色
        visualMap: {
          show: false,
          min: 0,
          max: 100,
          left: "left",
          top: "bottom",
          text: ["高", "低"],
          calculable: true,
          inRange: {
            color: [
              "#06A1E7",
              "#2B72D6",
              "#ADBFFF",
              "#328DDF",
              "#6676EF",
              "#A5D3F0"
            ]
          }
        },
        // 自定义引导饼图
        tooltip: {
          show: true,
          trigger: "item",
          backgroundColor: 'transparent',
          triggerOn: "mousemove",
          enterable: true,
          transitionDuration: 1,
          formatter: function(params) {
            const tipHtml =
              `<div id="bgImage" style="height:180px;width:306px;background: url(${tipbg}) no-repeat transparent;background-size:100% 100%;padding: 20px;">` +
              '    <div style="height: 15px;">产量分析 <span style="font-size: 10px">(吨)</span></div>' +
              '    <div id="tooltipPieId" style="height:135px;width:100%"></div>' +
              "</div>";
            setTimeout(function() {
              tooltipCharts();
            }, 10);
            return tipHtml;
          },
          borderWidth: 0,
          padding: 0
        },
        geo: {
          map: "百色市",
          show: true,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "red",
              borderColor: "#BCC5EA",
              borderWidth: 0,
              shadowColor: "#fff",
              shadowBlur: 0
            }
          },
          zoom: 1.2
        },
        series: [
          {
            type: "map",
            map: "百色市",
            geoIndex: 1,
            aspectScale: 0.75,
            zoom: 1.2,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#fff",
                  fontSize: 18
                }
              },
              emphasis: {
                textStyle: {
                  color: "#fff",
                  fontSize: 18
                }
              }
            },
            roam: false,
            itemStyle: {
              normal: {
                areaColor: "#328DDF",
                borderColor: "#BCC5EA",
                borderWidth: 1
              },
              emphasis: {
                areaColor: "#66b616",
                borderColor: "#f1c22f"
              }
            },
            data
          },
          {
            name: "产品图片",
            type: "scatter",
            coordinateSystem: "geo3D",
            label: {
              normal: {
                show: true,
                formatter: function(params) {
                  const val = params.data.value[2];
                  if (val === 10) {
                    return "{a|}";
                  }
                  if (val === 20) {
                    return "{b|}";
                  }
                  if (val === 30) {
                    return "{c|}";
                  }
                },
                rich: {
                  a: {
                    backgroundColor: {
                      image: "https://s2.ax1x.com/2019/05/20/Extm4S.png"
                    },
                    width: 60,
                    height: 60
                  },
                  b: {
                    backgroundColor: {
                      image: "https://s2.ax1x.com/2019/05/21/Ez0z0H.png"
                    },
                    width: 60,
                    height: 60
                  },
                  c: {
                    backgroundColor: {
                      image: "https://s2.ax1x.com/2019/05/21/EzB9AA.png"
                    },
                    width: 60,
                    height: 60
                  }
                }
              }
            },
            itemStyle: {
              normal: {
                color: "#1C3E64"
              }
            },
            zlevel: 6,
            data: convertData(data)
          }
        ]
      };
      self.myChart.setOption(option);
      // 切换具体的子地图
      self.myChart.on("click", function(params) {
        const { name } = params;
        if (name === '田阳县') {
          self.$router.push(`/secondMap?areaName=${name}`);
        }
      });
      let index = 2;
      setInterval(function() {
        self.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index
        });
        // index++;
        // if (index >= data.length) {
        //   index = 0;
        // }
      }, 3000);
    });
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// index.vue?9098e5dc